import { jsx } from 'react/jsx-runtime';
import 'react';

const Arrow = ({ testId, className })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "5",
        height: "10",
        viewBox: "0 0 5 10",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.96244e-08 5L5 -1.10263e-07L5 10L5.96244e-08 5Z",
            fill: "black"
        })
    });
};

export { Arrow };
